import * as Sentry from '@sentry/react';
import {
  PayCommissionPreview_Create,
  postV1CompaniesCompanyIdPayCommissionPreviews,
} from '@treadinc/horizon-api-spec';
import { useCallback } from 'react';

import { PayCommissionPreview } from './models';

export default function usePayCommissionPreview() {
  const preview = useCallback(
    async (companyId: string, body: PayCommissionPreview_Create, signal: AbortSignal) => {
      try {
        const response = await postV1CompaniesCompanyIdPayCommissionPreviews({
          path: { 'company-id': companyId },
          body,
          signal,
        });
        return PayCommissionPreview.parse(response.data.data);
      } catch (error) {
        if (signal.aborted) {
          throw error;
        }

        // Sentry, not handleRequestError: the caller renders its own inline error and must not get a toast.
        Sentry.captureException(error, { extra: { companyId } });
        throw error;
      }
    },
    [],
  );
  return { preview };
}
